import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "元", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "% 折扣（如输入 10 表示打9折）", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "元（0 表示无门槛）", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "元（0 表示不限制）", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("1抽")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("3抽")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("5抽")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("10抽")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px"}
}, "留空表示适用所有抽数", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "（0 表示不限量）", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "（0 表示不限制）", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("固定时间段")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("领取后天数")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("长期有效")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "天（用户领取后开始计算）", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted",
  style: {"font-size":"12px"}
}, "关闭后用户无法在优惠券中心领取，只能由管理员发放", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.coupon,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "优惠券名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.coupon.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.coupon.name) = $event)),
              placeholder: "请输入优惠券名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "优惠券类型",
          prop: "coupon_type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.coupon.coupon_type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.coupon.coupon_type) = $event)),
              placeholder: "请选择类型",
              disabled: !_ctx.isNew
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "满减券",
                  value: "fixed"
                }),
                _createVNode(_component_el_option, {
                  label: "折扣券",
                  value: "percent"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        (_ctx.coupon.coupon_type === 'fixed')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "优惠金额",
              prop: "discount_value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.coupon.discount_value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.coupon.discount_value) = $event)),
                  min: 0.01,
                  precision: 2,
                  step: 1
                }, null, 8, ["modelValue", "min"]),
                _hoisted_2
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.coupon.coupon_type === 'percent')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "折扣比例",
              prop: "discount_value"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.coupon.discount_value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.coupon.discount_value) = $event)),
                  min: 1,
                  max: 99,
                  precision: 0
                }, null, 8, ["modelValue"]),
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "使用门槛",
          prop: "min_amount"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.coupon.min_amount,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.coupon.min_amount) = $event)),
              min: 0,
              precision: 2
            }, null, 8, ["modelValue"]),
            _hoisted_4
          ]),
          _: 1
        }),
        (_ctx.coupon.coupon_type === 'percent')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: "最高优惠",
              prop: "max_discount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.coupon.max_discount,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.coupon.max_discount) = $event)),
                  min: 0,
                  precision: 2
                }, null, 8, ["modelValue"]),
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "适用套系",
          prop: "box_info_ids"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.coupon.box_info_ids,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.coupon.box_info_ids) = $event)),
              multiple: "",
              filterable: "",
              remote: "",
              "reserve-keyword": "",
              "remote-method": _ctx.searchBoxInfos,
              loading: _ctx.boxInfoLoading,
              placeholder: "搜索并选择适用的套系（留空表示全部适用）",
              style: {"width":"400px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boxInfoOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "remote-method", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "适用抽数",
          prop: "allowed_times"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: _ctx.coupon.allowed_times,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.coupon.allowed_times) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, { label: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: 3 }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: 5 }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_checkbox, { label: 10 }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "发放总量",
          prop: "total_quantity"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.coupon.total_quantity,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.coupon.total_quantity) = $event)),
              min: 0
            }, null, 8, ["modelValue"]),
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "每人限领",
          prop: "per_user_limit"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.coupon.per_user_limit,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.coupon.per_user_limit) = $event)),
              min: 0
            }, null, 8, ["modelValue"]),
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "有效期类型",
          prop: "validity_type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.validityType,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.validityType) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: "range" }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "days" }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "forever" }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.validityType === 'range')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: "有效期",
              prop: "time_range"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.timeRange,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.timeRange) = $event)),
                  type: "datetimerange",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  format: "YYYY-MM-DD HH:mm",
                  "value-format": "YYYY-MM-DDTHH:mm:ss"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.validityType === 'days')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: "有效天数",
              prop: "validity_days"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.coupon.validity_days,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.coupon.validity_days) = $event)),
                  min: 1,
                  max: 365
                }, null, 8, ["modelValue"]),
                _hoisted_16
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "状态",
          prop: "status"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.coupon.status,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.coupon.status) = $event)),
              "active-value": "active",
              "inactive-value": "inactive",
              "active-text": "启用",
              "inactive-text": "停用"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "允许领取",
          prop: "allow_user_claim"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.coupon.allow_user_claim,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.coupon.allow_user_claim) = $event)),
              "active-text": "开放",
              "inactive-text": "关闭"
            }, null, 8, ["modelValue"]),
            _hoisted_17
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}